// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/stylesheets/_payslider.scss
 ** module id = 471
 ** module chunks = 1
 **/